import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import Button from '../ui/Button';
import Icon from '../ui/Icon';
import { ICONS } from '../ui/icon-map';

const AuthStatus = () => {
    const { currentUser } = useAuth();

    if (!currentUser) {
        return (
            <div
                role="alert"
                dir="rtl"
                className="flex items-start gap-3 px-4 py-3 mb-4 rounded-lg border text-sm"
                style={{ background: 'var(--warning-soft)', borderColor: 'var(--warning-200)', color: 'var(--text)' }}
            >
                <Icon glyph={ICONS.warning} size="sm" tone="warning" className="mt-0.5" />
                <div className="flex-1">
                    <strong className="font-semibold">Not signed in</strong>
                    <p className="text-gray-600">Sign in to see the contracts.</p>
                    <Button
                        variant="primary"
                        size="sm"
                        className="mt-2"
                        onClick={() => window.location.href = '/login'}
                    >
                        Sign in
                    </Button>
                </div>
            </div>
        );
    }

    return null;
};

export default AuthStatus;
